import { render, staticRenderFns } from "./help-modal.vue?vue&type=template&id=0c88179b&scoped=true"
import script from "./help-modal.vue?vue&type=script&lang=js"
export * from "./help-modal.vue?vue&type=script&lang=js"
import style0 from "./help-modal.vue?vue&type=style&index=0&id=0c88179b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c88179b",
  null
  
)

export default component.exports